<div class="container" >
  <div class="row justify-content-start">
    <div class="col-12" *ngIf="periods && showPeriodChange">
      <div class="border-bottom border-secondary mt-2 mb-3 pb-3">
        <button type="button" *ngFor="let period of periods; trackBy: trackByPeriodId" (click)="selectPeriod(period.TimePeriodID)" class="btn btn-sm me-2"
          [class.btn-light]="periodSelected.TimePeriodID == period.TimePeriodID"
          [class.btn-outline-light]="periodSelected.TimePeriodID !== period.TimePeriodID">
            {{ period.TimePeriodName }}
        </button>
      </div>
    </div>
  </div>
</div>